module.exports = __webpack_public_path__ + "img/success-ticket.eaacb252.svg";